module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-breadcrumb",
    attrs: {
      "separator": "/"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "breadcrumb"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return (item.meta.title) ? _c('el-breadcrumb-item', {
      key: item.path
    }, [(item.redirect === 'noredirect' || index == _vm.levelList.length - 1) ? _c('span', {
      staticClass: "no-redirect"
    }, [_vm._v(_vm._s(item.meta.title))]) : _c('router-link', {
      attrs: {
        "to": item.redirect || item.path
      }
    }, [_vm._v(_vm._s(item.meta.title))])], 1) : _vm._e()
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dbcd8bac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Breadcrumb.vue
// module id = 470
// module chunks = 2